/* eslint-disable camelcase */

import { PaymentMethodsCommandNames, ValidationManager, SpecType, sendRioEvent, SubType } from '@chegg/commerce-utils';
var getMopError = ValidationManager.ValidationMessages.getMopError;
import { Component } from '../../../constants/CallbackConstants';
import { StatusTypes } from '@chegg/commerce-utils';
import { doFireStatusUpdate, sendRioEventCallback } from '../../../utils/CallbackUtils';
import { createMOPError } from '../PaymentState.actions';
import { sendNewRelicMessage } from '../../../utils/NewRelicUtils';
import { ErrorType } from '../../../constants/Errors';
/**
 * handleCreateMopError handles errors from create mop API
 */

export var handleCreateMopError = function handleCreateMopError(params) {
  var response = params.response,
    dispatch = params.dispatch,
    matchedCards = params.matchedCards,
    rioNamespace = params.rioNamespace,
    paymentType = params.paymentType;
  var _ref = response.data,
    errors2 = _ref.errors2;
  if (errors2) {
    var _errors2$ = errors2[0],
      code = _errors2$.code,
      message = _errors2$.message;
    var _getMopError = getMopError(code),
      message_detail = _getMopError.message_detail,
      message_id = _getMopError.message_id,
      message_name = _getMopError.message_name;
    var rioMessage = message || message_detail;
    doFireStatusUpdate([{
      status: StatusTypes.ERROR,
      command: PaymentMethodsCommandNames.FETCH_PAYMENT_METHOD,
      payload: {
        component: Component.PAYMENT_MODULE_LOGIC,
        errors: errors2
      }
    }]);
    if (code === 'pmt30026') {
      var creditCardType = Object.getOwnPropertyNames(matchedCards)[0];
      var unsupportedCardTypeError = {
        message: 'Unsupported card type: ' + creditCardType,
        type: ErrorType.SERVER,
        field: null
      };
      errors2.push(unsupportedCardTypeError);
      sendNewRelicMessage('CreateMopLogic: Unsupported card type(pmt30026)', {
        errors: JSON.stringify(errors2)
      });
      dispatch(createMOPError({
        message: {
          text: message,
          type: StatusTypes.ERROR,
          code: message_id
        },
        rawData: response.data
      }));
      sendRioEvent({
        info: message_name,
        specType: SpecType.NOTIFICATION,
        subType: SubType.ERROR,
        callback: sendRioEventCallback,
        namespace: rioNamespace,
        message_detail: "".concat(paymentType, " ").concat(rioMessage),
        message_id: message_id
      });
    } else {
      sendNewRelicMessage("CreateMopLogic: ".concat(JSON.stringify(errors2)));
      dispatch(createMOPError({
        message: {
          text: message_detail,
          type: StatusTypes.ERROR,
          code: message_id
        },
        rawData: response.data
      }));
      sendRioEvent({
        info: message_name,
        specType: SpecType.NOTIFICATION,
        subType: SubType.ERROR,
        callback: sendRioEventCallback,
        namespace: rioNamespace,
        message_detail: "".concat(paymentType, " ").concat(rioMessage),
        message_id: message_id
      });
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/redux/PaymentState/helpers/handleCreateMopError.js
// module id = 4391
// module chunks = 11